import * as React from 'react';

import { DataPoint } from 'Interfaces/DataPoint';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import { getFormUtils } from 'views/SingleInstance/utils/FormUtilsHolder';
import FormUtils from 'views/SingleInstance/utils/FormUtils';
import { isNullOrUndefined } from 'utils/utils';
import { getLocalization } from 'global/global';
import StatusColumn from 'views/KanbanBoard/StatusColumn';
import { DragDropProvider } from '@dnd-kit/react';
import { ListItem } from 'Interfaces/Forms/QuestionInterface';
import { DroppedDataPoint } from 'views/KanbanBoard';
import { organizeStatusData } from 'views/KanbanBoard/util';


interface Props {
  dataPoints: DataPoint[];
  form: FormInterface;
  extraFields: string[];
}

const TASK_STATUS = 'taskstatus';

export default function TaskKanban(props: Props) {

  const { dataPoints, form, extraFields } = props;
  const formUtils = React.useRef<FormUtils | null>(null);

  const [statuses, setStatuses] = React.useState<ListItem[]>([]);

  const [dropped, setDropped] = React.useState<DroppedDataPoint | null>(null);

  const [data, setData] = React.useState<DataPoint[][]>([]);

  React.useEffect(() => {
    if (form) {
      formUtils.current = getFormUtils(form);
      const status = formUtils.current.getQuestion(TASK_STATUS);
      if (status && status.listItems) {
        setStatuses(status.listItems.listItem);
      }
    }
  }, [form]);

  React.useEffect(() => {
    if (statuses.length && dataPoints.length) {
      const newData = organizeStatusData(dataPoints, statuses, TASK_STATUS);
      setData(newData);
    }
  }, [dataPoints, statuses]);

  const getDivRows = React.useCallback(() => {
    // const severityListItem = formUtils.current?.getQuestion(severityId)?.listItems?.listItem;
    const columns = statuses.map((status, index) => (
      <StatusColumn
        key={`kboard-${status.value}-${index}`}
        index={index}
        status={status}
        dataPoints={data[index] || []}
        severityListItem={[]}
        extraFields={extraFields}
        formUtils={formUtils.current}
        showMultiViewer={(dp) => console.log(dp)}
      />
    ));
    return (
      <div className="row">
        <DragDropProvider
          onDragEnd={(event) => {
            const { source, target } = event.operation;
            if (target && source) {
              console.log(`Dropped ${source.id} onto ${target.id}`);
              const id = `${target.id}`.substring(`${target.id}`.indexOf('-') + 1, `${target.id}`.lastIndexOf('-'));
              setDropped({ status: id, id: `${source.id}`, oldStatus: `${source.data.status}` });
            }
          }}
        >
          {columns}
        </DragDropProvider>
      </div>
    );
  }, [data, dropped, extraFields]);

  return (
    <div className="mt-3">
      <div className="container-fluid kanban-body mb-3">
        <div className="row header-row">
          {statuses.map((listIItem: ListItem, index) => (
            <div key={`kanban-th-${listIItem.id}`} className="col kanban-header">
              <span className="header-title">{listIItem.value}</span>
              <div className="counts mt-1">
                {isNullOrUndefined(data[index]) ? 0 : data[index].length} {getLocalization('tasksModuleBtn')}
              </div>
            </div>
          ))}
        </div>
        {getDivRows()}
      </div>
    </div>
  );
}
